import { ImageWithFallback } from '~/components/ui/ImageWithFallback';
import styles from '~/features/Influencer/Influencer.module.scss';
import React from 'react';
import cn from 'classnames';

export function InfluencerHeroDesktopWhilePlaying(props: {
  src: string;
  alt: string;
  videoIsLive: boolean;
}) {
  return (
    <div className={'px-4 mt-5 flex justify-center items-center'}>
      <ImageWithFallback
        src={props.src}
        alt={props.alt}
        className={cn(styles.influencerAvatar, 'flex-shrink-0')}
      />

      <div className={'px-4'}>
        <h1 className={'text-2xl font-semibold'}>
          {!props.videoIsLive && 'Previous '} Live Sale with {props.alt}
        </h1>

        {props.videoIsLive && (
          <div
            className={
              'px-2 py-1 text-white font-bold rounded inline-block inline-flex items-center'
            }
            style={{ backgroundColor: 'var(--color-error)' }}
          >
            <span
              className={'inline-block rounded-full bg-white w-2 h-2 mr-2'}
            />
            LIVE NOW
          </div>
        )}
      </div>
    </div>
  );
}
